import {addQueryToPath} from '../../../libs/shared/helpers/src/browser/urlHelpers';

interface SearchLensOptions {
  namespace: string;
  /** Only list lenses after the offset. */
  offset?: number;
  /** Limits the number of lenses returned in the response. */
  limit?: number;
}

export function buildLensSearchUrl(companyUrl: string, query: string, options: SearchLensOptions) {
  return addQueryToPath(
    `${companyUrl}/namespaces/${options.namespace}/search_lens/${encodeURIComponent(query.toLowerCase())}`,
    {
      offset: options.offset ?? 0,
      limit: options.limit ?? 50,
    },
  );
}
